import { Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

function SettingsDomains() {
    return (
        <div className="marketing-settings__domains">
            <div className="marketing-settings__domains__header">
                <Text type="h5" bold>
                    {getLiteral('label_marketing_campaigns_domain_verification')}
                </Text>
            </div>
        </div>
    );
}

SettingsDomains.displayName = 'SettingsDomains';

export default SettingsDomains;
